module.exports = __webpack_public_path__ + "static/media/events.15e65b0d.png";